const SocialMediaBar = () => {
  return (
    <ul className="social-media">
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.amazon.com/stores/C.-W.-Hambleton/author/B00CWRMYXA"
        >
          <i className="fab fa-amazon"></i>
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.facebook.com/cwhambleton"
        >
          <i className="fab fa-facebook"></i>
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href="https://x.com/cwhambletonbks">
          <i className="fab fa-x-twitter"></i>
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.youtube.com/@cwhambletonbooks"
        >
          <i className="fab fa-youtube"></i>
        </a>
      </li>
      {/* <li>
        <a    target="_blank"
          rel="noreferrer" href="https://www.linkedin.com/in/chris-hambleton-a1b1703">
          <i className="fab fa-linkedin"></i>
        </a>
      </li> */}
      {/* <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/cwhambletonbooks/"
        >
          <i className="fab fa-instagram"></i>
        </a>
      </li> */}
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.goodreads.com/author/show/2796110.Chris_Hambleton"
        >
          <i className="fab fa-goodreads"></i>
        </a>
      </li>
    </ul>
  );
};

export default SocialMediaBar;
